module.exports = __webpack_public_path__ + "media/images/hapier1-28ea663c4e37889fb13acdc038463a86.png";